export default "/react/logoWebjack-1f4f80e0.png";